import { StrictMode, useState } from "react";
import { Location, LocationNames } from './SceneComponents/Location.jsx';

export function App() {
	const urlParams = new URLSearchParams(window.location.search);
	const urlLocation = urlParams.get('location');
	const urlPureVideo = urlParams.get('pureVideo');
	const pureVideo = urlPureVideo === '1';
	const locationName = LocationNames.hasOwnProperty(urlLocation) ? urlLocation : LocationNames.A;
	const [location, setLocation] = useState(locationName); 
	return <StrictMode>
		<>
			<Location location={location} setLocation={setLocation} setPureVideo={pureVideo} />			
		</>
	</StrictMode>
}
	